import { useDispatch } from 'react-redux';
import { updateConfigError } from "../redux/dashboardSlice";

export const useSetConfigError = (id) => {
  const dispatch = useDispatch();
  return (path, value) => {
    dispatch(updateConfigError({ id, path, value }));
  };
}
